module.exports = __webpack_public_path__ + "static/img/アセット 28@2x.096100e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/meal_history/アセット 28@2x.png
// module id = 1Cee
// module chunks = 1